import type React from 'react';
import type { BaseAdConfig } from 'interfaces/ads/Ad';
import { StickyFooterAd } from './Styles';
import AdSlotToggle from './AdSlotToggle';

const StickyFooter: React.FC<BaseAdConfig> = ({ id }: BaseAdConfig) => (
  <StickyFooterAd>
    <AdSlotToggle
      placementName='StickyFooter'
      index={id + 1}
      slotId={`StickyFooter_Articles${id}`}
      dataCy='sticky-footer-ad'
      sticky
    />
  </StickyFooterAd>
);

export default StickyFooter;
